module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize:debounce.100",
      value: (_vm.onResize),
      expression: "onResize",
      arg: "debounce",
      modifiers: {
        "100": true
      }
    }],
    ref: "plotlyPlot"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f28e528"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PlotlyWidget.vue
// module id = 640
// module chunks = 0